import PharmacistPromoCodePage from './PharmacistPromoCodePage';

export default PharmacistPromoCodePage;
